import api from "./api";

// Toute vidéo YouTube (cours, lives, rediffusions, formules, démo) passe par la page
// relais du site (/lecteur/youtube/<id>/), servie en https :
// - l'app Mac affiche ses pages depuis tauri://localhost : intégrée directement,
//   YouTube refuse la vidéo (erreur 153) faute de référent http(s) ;
// - la page recouvre l'interface de YouTube : le lien de la vidéo reste secret.
export const AUTORISATIONS_LECTEUR = "autoplay; encrypted-media; fullscreen; picture-in-picture";

export const origineSite = () => new URL(api.defaults?.baseURL || "/", window.location.href).origin;

export const urlLecteurYoutube = (ytId, { depart = 0, direct = false } = {}) => {
  const params = `?depart=${Math.max(0, Math.floor(Number(depart) || 0))}${direct ? "&direct=1" : ""}`;
  return `${origineSite()}/lecteur/youtube/${encodeURIComponent(ytId)}/${params}`;
};
